import React from "react";
import _ from "lodash/fp";

import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";

// import { yupResolver } from "@hookform/resolvers";
// import { useFormikContext, Field } from "formik";
import classNames from "classnames";

import { MuiAutoComplete } from "../../../../components/AutoComplete/MuiAutoComplete";
import InvoiceItemsList from "./InvoiceItemsList";

// const validationSchema = yup.object().shape({
//   paymentTerms: yup.string().required("Payment Terms is required."),
//   // age: yup.number().positive().integer().required(),
// });

const InvoiceDetailsForm = (props) => {
  const { register, control, errors, getValues, setValue } = props;

  const onDiscountChange = () => {
    const subTotal = getValues("subTotal");
    const discount = getValues("discount");

    let newTotalAmount = parseFloat(subTotal - discount, 10).toFixed(2);
    if (subTotal - discount < 0) newTotalAmount = 0;

    setValue("totalAmount", newTotalAmount);
  };

  return (
    <div>
      <div className="md:flex ">
        {/* Invoice Number */}

        <div className="w-full md:w-1/2 mb-4 md:pr-6">
          <label
            className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="paymentTerms"
          >
            Payment Terms
          </label>

          <MuiAutoComplete
            autoComplete={true}
            control={control}
            getOptionLabel={(option) => option.value}
            renderOption={(option) => <span>{option.value}</span>}
            getOptionSelected={(option, value) => _.isEqual(option, value)}
            options={[
              { value: "Due on Receipt" },
              { value: "Paytm" },
              { value: "GPay" },
              { value: "Settle by cash now" },
            ]}
            name="paymentTerms"
            inputProps={{ placeholder: "Select Payment terms" }}
            defaultValue={{
              value: "Due on Receipt",
            }}
            // customChangeCB={updatePaymentMode}
          />

          {errors.paymentTerms && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.paymentTerms.message}</span>
            </div>
          )}
        </div>
      </div>

      <hr className="border b-1 mb-6" />

      <div className="md:flex">
        {/* Invoice Date */}
        <div className="md:w-1/2 w-full mb-4 md:pr-6">
          <label
            className="block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="invoicedate"
          >
            Invoice Date
          </label>

          <input
            className={classNames({
              "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500": true,
              "border border-red-500 b-2 text-red-500": errors.invoiceDate,
            })}
            placeholder="Invoice Date"
            type="date"
            name="invoiceDate"
            ref={register}
            defaultValue={Date()}
            // onBlur={handleBlur}
            // value={values.invoicedate}
            // onChange={handleChange}
          />
          {errors.invoiceDate && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.invoiceDate.message}</span>
            </div>
          )}
        </div>
        {/* Payment Terms */}
        <div className="md:w-1/2 w-full mb-4">
          <label
            className="block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="dueDate"
          >
            Due Date
          </label>

          <input
            className={classNames({
              "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500": true,
              "border border-red-500 b-2 text-red-500": errors.dueDate,
            })}
            placeholder="Due Date"
            type="date"
            name="dueDate"
            ref={register}
            // onBlur={handleBlur}
            // value={values.dueDate}
            // onChange={handleChange}
          />
          {errors.dueDate && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.dueDate.message}</span>
            </div>
          )}
        </div>
      </div>

      <hr className="border b-1 mb-6" />

      <div className="md:flex">
        {/* Subject */}
        <div className="w-full mb-4">
          <label
            className="block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="invoiceSubject"
          >
            Subject
          </label>

          <input
            className={classNames({
              "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500": true,
              "border border-red-500 b-2 text-red-500": errors.invoiceSubject,
            })}
            placeholder="Invoice Subject"
            name="invoiceSubject"
            ref={register}
            // onBlur={handleBlur}
            // value={values.invoiceSubject}
            // onChange={handleChange}
          />
          {errors.invoiceSubject && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.invoiceSubject.message}</span>
            </div>
          )}
        </div>
      </div>

      {/* Items List with Total Amount */}
      <InvoiceItemsList {...props} />

      <div className="my-8 md:flex">
        {/* Custom Notes */}
        <div className="md:w-1/2 w-full md:pr-6 pt-4">
          <label
            className="block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="customNotes"
          >
            Notes to the Customer ( optional )
          </label>

          <textarea
            className={classNames({
              "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500": true,
              "border border-red-500 b-2 text-red-500": errors.customNotes,
            })}
            placeholder="You can write a custom note with the Invoice."
            name="customNotes"
            ref={register}
            // value={values.customNotes}
            // onChange={handleChange}
          />
          {errors.customNotes && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.customNotes.message}</span>
            </div>
          )}
        </div>
        {/* Total Amount Generator */}
        <div className="flex flex-col justify-center sm:px-10 py-4 md:w-1/2 w-full mb-3 bg-white">
          <div className="flex flex-1 flex-row justify-between items-center mb-2 px-2">
            <div className="flex flex-4">
              <label
                className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium"
                htmlFor="subTotal"
              >
                Sub Total
              </label>
            </div>
            <div className="flex flex-2 ml-5 xl:ml-6">
              <TextField
                placeholder="sub-total"
                name="subTotal"
                inputRef={register}
                inputProps={{ readOnly: true, defaultValue: 0 }}
                disabled
              />
            </div>
          </div>
          <div className="flex flex-1 flex-row justify-between items-center mb-4 px-2">
            <div className="flex flex-4">
              <label
                className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium"
                htmlFor="discount"
              >
                Discount
              </label>
            </div>
            {/* <div className="flex flex-2 ml-2"> */}
            <div className="flex flex-2 ml-5 xl:ml-6">
              <TextField
                // class="text-green-500"
                placeholder="₹"
                name="discount"
                inputRef={register}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">-</InputAdornment>
                  ),
                }}
                inputProps={{
                  className: "text-green-800",
                  type: "number",
                  min: 0,
                }}
                color="primary"
                onChange={onDiscountChange}
                disabled
                // inputProps={{ defaultValue: 0 }}
              />
            </div>
            {/* </div> */}
          </div>
          <div className="flex flex-1 flex-row justify-between items-center mb-2 p-2 bg-yellow-100">
            <div className="flex flex-4">
              <label
                className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium"
                htmlFor="totalAmount"
              >
                Total Amount
              </label>
            </div>
            <div className="flex flex-2 ml-5 xl:ml-6">
              <TextField
                placeholder="Total-Amount"
                name="totalAmount"
                inputRef={register}
                inputProps={{ readOnly: true, defaultValue: 0 }}
              />
            </div>
          </div>
        </div>
      </div>

      <hr className="border b-1 mb-6" />

      <div className="md:flex">
        {/* Terms and Conditions */}
        <div className="w-full">
          <label
            className="block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="termsAndConditions"
          >
            Terms and Conditions
          </label>

          <textarea
            className={classNames({
              "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500": true,
              "border border-red-500 b-2 text-red-500":
                errors.termsAndConditions,
            })}
            placeholder="You can specify any Terms and Conditions to the customer."
            name="termsAndConditions"
            ref={register}
            // value={values.termsAndConditions}
            // onChange={handleChange}
          />
          {errors.termsAndConditions && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.termsAndConditions.message}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(InvoiceDetailsForm);
